// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".notice[data-v-a169ed8e]{margin-top:4px}.maxHeight[data-v-a169ed8e]{max-height:60px;overflow-y:hidden;text-overflow:ellipsis}.show-more[data-v-a169ed8e]{position:absolute;right:-10px;bottom:-8px;font-size:14px!important}.show-more img[data-v-a169ed8e]{margin-left:3px}", ""]);
// Exports
module.exports = exports;
